module.exports = __webpack_public_path__ + "static/scale-model-of-casi-in-davenport-iowa-153378e866488cbd290403454c46ba9d.png";